"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingCustomerSalesOrderStatus = void 0;
const React = require("react");
const labels_1 = require("../../../types/labels");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "PendingCustomerSalesOrderStatus");
const PendingCustomerSalesOrderStatus = ({ salesOrder }) => {
    const { status, retailLocation: { locationImageUrl } } = salesOrder;
    return (React.createElement("div", { className: css(""), style: {
            backgroundImage: `url("${locationImageUrl}")`
        } },
        React.createElement("div", { className: css("status") },
            React.createElement("div", { className: css("status_label", `-${status}`) }, labels_1.salesOrderStatusLabels[status]))));
};
exports.PendingCustomerSalesOrderStatus = PendingCustomerSalesOrderStatus;
//# sourceMappingURL=index.js.map